import React from "react";
import Combobox from "Components/Combobox";
import WayPoints from "Components/Waypoints";

interface Props {
  instructions: string[];
  combinedStops: { title: string; realLat: number; realLng: number }[];
  setStartId: (id: number) => void;
  setEndId: (id: number) => void;
}

const ADADirections = (props: Props) => {
  const { instructions, combinedStops, setStartId, setEndId } = props;
  const options = combinedStops.map((stop: any) => {
    return {
      name: stop.title,
      id: stop.id,
    };
  });
  return (
    <>
      <Combobox
        placeHolder="Choose Start Location"
        label="Choose Start Location"
        options={options}
        onSelectionChange={setStartId}
      />
      <div style={{ height: "25px" }} />
      <Combobox
        placeHolder="Choose End Location"
        label="Choose End Location"
        options={options}
        onSelectionChange={setEndId}
      />
      <WayPoints steps={instructions} showTitle />
    </>
  );
};

export { ADADirections };
